import { Box, Text, Progress } from '@chakra-ui/react';
import { getQuestionCount } from '../utils';

const AnsweredPersonalized = props => {
  if (props.stateProps.sectionData.sectionType !== 'industry') {
    return null;
  } else {
    const [questionCount, answeredQuestionCount] = getQuestionCount(props);
    const progressValue = (answeredQuestionCount * 100) / questionCount;

    if (answeredQuestionCount === questionCount) {
      return null;
    } else
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            minWidth: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center',
              minHeight: '100px',
              width: '100%',
              maxWidth: '1000px',
              border: '1px solid',
              borderRadius: 4,
              borderColor: 'NAVY',
              backgroundColor: '#e0e7ff',
              padding: ['4px 24px', null, '4px 48px'],
              marginTop: '8px',
              color: 'NAVY',
            }}
          >
            <Text
              sx={{
                color: 'inherit',
                textAlign: 'center',
                fontSize: ['14px', null, '16px'],
              }}
            >
              Answer this question to unlock a personalized bullet.
            </Text>
            <Progress
              width="full"
              value={progressValue}
              borderRadius={4}
              padding="1px"
              backgroundColor="white"
              border="1px solid"
              borderColor="gray.400"
              colorScheme="orangeScheme"
              opacity={0.5}
            />
            <Text
              sx={{ color: 'inherit', textAlign: 'center', fontSize: '14px' }}
            >
              {answeredQuestionCount} out of {questionCount} personalized bullets unlocked.
            </Text>
          </Box>
        </Box>
      );
  }
};

export default AnsweredPersonalized;
